import { Component, Input } from '@angular/core';

/**
 * Corner link back to a page's legacy version while its NDS3 rebuild settles (Logic\UiVersion on the server).
 * `legacy_path` is the setup-relative legacy URL; following it with `ui=old` stores the user's choice.
 */
@Component({
	selector    : 'app-ui-version-switch',
	templateUrl : './ui-version-switch.component.html',
	styleUrls   : ['./ui-version-switch.component.scss'],
})
export class UiVersionSwitchComponent {
	@Input({ required: true }) legacy_path!: string;

	get legacyHref(): string {
		const separator = this.legacy_path.includes('?') ? '&' : '?';

		return `${this.legacy_path}${separator}ui=old`;
	}
}
